import React, { useEffect, useRef, useState } from "react";
import { Container, Grid2 } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBox,
  faCheckCircle,
  faChevronRight,
  faPeopleCarryBox,
  faTriangleExclamation,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import PackagingCard from "../components/common/PackagingCard";
import StickyStripe from "../components/common/StickyStripe";
import productService from "../services/productService";
import Breadcrumbs from "../components/common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { handleErrors } from "../utils/error-handler";
import { ErrorHandlingDesign } from "../components/common/errorHandlingDesign";
const DishPackagingInfo = () => {
  const navbarRef = useRef(null);
  const location = useLocation();
  const { subCategoryURL, category } = useParams();
  const id = subCategoryURL?.split("-").pop();
  const { subCategoryUrl, categoryUrl } = location.state || {};

  const [serviceDetails, setServiceDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchServiceDetails = async () => {
      if (!id) {
        return;
      }
      try {
        const data = await productService.getServiceDetails(id);
        setServiceDetails(data);
        setError(null);
      } catch (error) {
        setError("Failed to load data.");
        handleErrors(error);
      } finally {
        setLoading(false);
      }
    };
    fetchServiceDetails();
  }, [id]);

  const FinalmenuItems = [
    {
      icon: faTriangleExclamation,
      label: "Common Issues",
      id: "common_issue",
    },
    {
      icon: faCheckCircle,
      label: "Packaging Tips",
      id: "packaging_tips",
    },
    {
      icon: faPeopleCarryBox,
      label: "Handling Tips",
      id: "handling_tips",
    },
    {
      icon: faBox,
      label: "Packaging Options",
      id: "packaging_options",
    },
  ];
  const visibleMenuItems = FinalmenuItems.filter((item) => {
    if (item.id === "common_issue") {
      return (
        Array.isArray(serviceDetails?.commonIssues) &&
        serviceDetails.commonIssues.length > 0
      );
    }
    if (item.id === "packaging_tips") {
      return (
        Array.isArray(serviceDetails?.packagingTips) &&
        serviceDetails.packagingTips.length > 0
      );
    }
    if (item.id === "handling_tips") {
      return (
        Array.isArray(serviceDetails?.handlingTips) &&
        serviceDetails.handlingTips.length > 0
      );
    }
    if (item.id === "packaging_options") {
      return (
        Array.isArray(serviceDetails?.packagingOptions) &&
        serviceDetails.packagingOptions.length > 0
      );
    }
    return false;
  });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize); // Update on window resize

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const CommonIssueCardSkeleton = () => (
    <div className="common-issue-card">
      <div className="common-issue-img">
        <Skeleton height={384} />
      </div>
      <div className="common-issue-content">
        <h3>
          <Skeleton width="100%" />
        </h3>
        <p>
          <Skeleton count={2} />
        </p>
      </div>

      <div className="swiper-pagination-skeleton">
        <Skeleton width={40} height={10} />
      </div>
    </div>
  );
  const HandlingTipsCardSkeleton = () => (
    <div className="handling-tips-card">
      <div className="inner-content">
        <h3>
          <Skeleton width="60%" />
        </h3>
        <p>
          <Skeleton count={2} />
        </p>
      </div>
      <div className="handling-tips-img">
        <Skeleton height={100} />
      </div>
    </div>
  );
  const PackagingTipsCardSkeleton = () => (
    <div className="packaging-tips-card">
      <div className="do-dont-icon">
        <Skeleton circle width={24} height={24} />
        <span>
          <Skeleton width={40} />
        </span>
      </div>
      <div className="inner-content">
        <div className="packaging-tips-img">
          <Skeleton height={100} />
        </div>
        <p>
          <Skeleton width="80%" />
        </p>
      </div>
    </div>
  );
  const PackagingCardSkeleton = () => (
    <div className="dish-card packaging-optiopn-card">
      <div className="dish-image">
        <Skeleton height={150} />
      </div>
      <div className="dish-content">
        <h4 className="title">
          <Skeleton width={100} />
        </h4>
        <p className="description">
          <Skeleton count={2} />
        </p>
        <div className="price-wrap">
          <p className="price">
            <Skeleton width={80} />
          </p>
          <ul className="packaging-options-list">
            <li>
              <Skeleton width={50} />
            </li>
            <li>
              <Skeleton width={50} />
            </li>
          </ul>
        </div>
        <div className="dish-btn">
          <Skeleton width={120} height={30} />
        </div>
      </div>
    </div>
  );
  return (
    <>
      {error ? (
        <ErrorHandlingDesign errorMessage={error} />
      ) : (
        <>
          <section className="dish-packaging-info inner-baner orange-bg-pattern">
            <Container>
              <div className="breadcrumb">
                <Breadcrumbs />
              </div>
              <div
                className="back-arrow text-white"
                onClick={() => navigate(-1)}
                style={{ cursor: "pointer" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M10.0164 2.86402C10.5046 2.41035 11.2681 2.43834 11.7218 2.92652C12.1754 3.41471 12.1475 4.17823 11.6593 4.63189L5.9091 9.97545C5.56441 10.2958 5.27721 10.5634 5.03763 10.795L21.7309 10.795C22.3974 10.795 22.9376 11.3353 22.9376 12.0017C22.9376 12.6681 22.3974 13.2084 21.7309 13.2084L4.96299 13.2084C5.21692 13.4563 5.52784 13.7462 5.90908 14.1005L11.5886 19.3785C12.0768 19.8322 12.1048 20.5957 11.6511 21.0839C11.1974 21.5721 10.4339 21.6 9.94575 21.1464L4.20777 15.814C3.51539 15.1707 2.90681 14.6052 2.48249 14.0857C2.02422 13.5246 1.65356 12.8684 1.65356 12.0379C1.65357 11.2075 2.02424 10.5513 2.48251 9.99021C2.90682 9.47068 3.51538 8.90523 4.20774 8.26193L10.0164 2.86402Z"
                    fill="#02060C"
                    fillOpacity="0.75"
                  />
                </svg>
              </div>

              <div className="banner-content-wrap">
                <div className="banner-content">
                  <h1 className="text-white">
                    Understand packaging issues <br />
                    and solutions for {serviceDetails?.subCategoryName}
                  </h1>
                  <p className="text-white mob-none">
                    Know everything about {serviceDetails?.subCategoryName}{" "}
                    packaging{" "}
                  </p>
                </div>
                <div className="packaging-option">
                  {serviceDetails?.packagingOptions?.length > 0 && (
                    <Link
                      to={`/${category}/${subCategoryURL}/packaging-options`}
                      className="btn btn-black text-nowrap packaging-option-btn"
                    >
                      <FontAwesomeIcon icon={faBox} className="mr-1" />{" "}
                      Packaging options
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className="right-arrow1"
                      />
                    </Link>
                  )}
                </div>
              </div>
            </Container>
          </section>
          <div className="sticky-material-menu">
            <section className="dish-material-menu">
              <Container>
                <div className="material-card-menu">
                  <ul className="packaging-info-list">
                    {!loading && visibleMenuItems.length > 0 && (
                      <ul className="packaging-info-list">
                        {visibleMenuItems.map((item, index) => (
                          <StickyStripe
                            navMenu={item}
                            key={index}
                            stickyMenuItems={visibleMenuItems}
                            navbarRef={navbarRef}
                            defaultActiveState="common_issue"
                          />
                        ))}
                      </ul>
                    )}
                  </ul>
                </div>
                {/* <MaterialCard menuItems={menuItems} /> */}
              </Container>
            </section>
            <section className="dish-wrapper">
              {loading ? (
                <Container>
                  <Grid2
                    container
                    spacing={2}
                    className="common-issue-wrap xs-gap-8"
                  >
                    {Array.from({ length: 2 }).map((_, index) => (
                      <Grid2 key={index} size={{ xs: 6, sm: 6, md: 4 }}>
                        <CommonIssueCardSkeleton />
                      </Grid2>
                    ))}
                  </Grid2>
                </Container>
              ) : (
                Array.isArray(serviceDetails?.commonIssues) &&
                serviceDetails.commonIssues.length > 0 && (
                  <Container>
                    <Grid2
                      container
                      spacing={2}
                      className="common-issue-wrap xs-gap-8"
                    >
                      <Grid2 size={{ sm: 12, md: 12, lg: 4 }} id="common_issue">
                        <div className="section-title section-title-mob mob-mb-8">
                          <h2>Common Issues</h2>
                          <p>
                            View most common packaging issues that customers
                            reported.
                          </p>
                        </div>
                      </Grid2>

                      {serviceDetails.commonIssues.map((issue) => (
                        <Grid2 key={issue.id} size={{ xs: 6, sm: 6, md: 4 }}>
                          <div className="common-issue-card">
                            <Swiper
                              slidesPerView={"auto"}
                              spaceBetween={20}
                              className="common-issue-slider"
                              pagination={{ type: "fraction" }}
                              modules={[Pagination]}
                            >
                              {issue.images.length > 0 &&
                                issue.images.map((image, imgIndex) => (
                                  <SwiperSlide key={imgIndex}>
                                    <div className="common-issue-img">
                                      <img src={image} alt={issue.title} />
                                    </div>
                                  </SwiperSlide>
                                ))}
                            </Swiper>
                            <div className="common-issue-content">
                              <h3>{issue.title}</h3>
                              <p>{issue.description}</p>
                            </div>
                          </div>
                        </Grid2>
                      ))}
                    </Grid2>
                  </Container>
                )
              )}
              {loading ? (
                <Container>
                  <Grid2
                    container
                    spacing={2}
                    className="inner-content-gap xs-justify-center xs-gap-8"
                  >
                    <Grid2 size={{ sm: 12, md: 4 }} id="packaging_tips">
                      <div className="section-title section-title-mob mob-mb-8">
                        <h2>Packaging Tips</h2>
                        <p className="mob-none">
                          Use these Do’s and Don’ts for solving all packaging
                          tips
                        </p>
                      </div>
                    </Grid2>
                    <Grid2 size={{ sm: 12, md: 8 }}>
                      <Grid2 container spacing={2}>
                        {Array.from({ length: 6 }).map((_, index) => (
                          <Grid2
                            key={index}
                            size={{ sm: 4, md: 6, lg: 4, xs: 6 }}
                          >
                            <PackagingTipsCardSkeleton />
                          </Grid2>
                        ))}
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Container>
              ) : (
                Array.isArray(serviceDetails?.packagingTips) &&
                serviceDetails.packagingTips.length > 0 && (
                  <Container>
                    <Grid2
                      container
                      spacing={2}
                      className="inner-content-gap xs-justify-center xs-gap-8"
                    >
                      <Grid2 size={{ sm: 12, md: 4 }} id="packaging_tips">
                        <div className="section-title section-title-mob mob-mb-8">
                          <h2>Packaging Tips</h2>
                          <p className="mob-none">
                            Use these Do’s and Don’ts for solving all packaging
                            tips
                          </p>
                        </div>
                      </Grid2>

                      <Grid2 size={{ sm: 12, md: 8 }}>
                        <Grid2 container spacing={2}>
                          {serviceDetails.packagingTips.map((tip) => (
                            <Grid2
                              key={tip.id}
                              size={{ sm: 4, md: 6, lg: 4, xs: 6 }}
                            >
                              <div className="packaging-tips-card">
                                <div
                                  className={`do-dont-icon ${
                                    tip.type === "DO" ? "does" : "donts"
                                  }`}
                                >
                                  <FontAwesomeIcon
                                    icon={
                                      tip.type === "DO"
                                        ? faCheckCircle
                                        : faXmark
                                    }
                                  />
                                  <span>
                                    {tip.type === "DO" ? "DO’s" : "DONT’s"}
                                  </span>
                                </div>
                                <div className="inner-content">
                                  <div className="packaging-tips-img">
                                    <img src={tip.imageURL} alt={tip.title} />
                                  </div>
                                  <p>{tip.title}</p>
                                </div>
                              </div>
                            </Grid2>
                          ))}
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Container>
                )
              )}

              {loading ? (
                <Container>
                  <Grid2
                    container
                    spacing={2}
                    className="inner-content-gap xs-justify-center xs-gap-8"
                  >
                    <Grid2 size={{ sm: 12, lg: 4, xs: 12 }} id="handling_tips">
                      <div className="section-title section-title-mob mob-mb-8">
                        <h2>Handling Tips</h2>
                        <p className="mob-none">
                          Use these Do’s and Don’ts for solving all packaging
                          tips
                        </p>
                      </div>
                    </Grid2>

                    <Grid2 size={{ sm: 12, md: 8, xs: 12 }}>
                      <Grid2 container spacing={2}>
                        {Array.from({ length: 2 }).map((_, index) => (
                          <Grid2 key={index} size={6}>
                            <HandlingTipsCardSkeleton />
                          </Grid2>
                        ))}
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Container>
              ) : (
                Array.isArray(serviceDetails?.handlingTips) &&
                serviceDetails.handlingTips.length > 0 && (
                  <Container>
                    <Grid2
                      container
                      spacing={2}
                      className="inner-content-gap xs-justify-center xs-gap-8"
                    >
                      <Grid2 size={{ sm: 12, md: 4 }} id="handling_tips">
                        <div className="section-title section-title-mob mob-mb-8">
                          <h2>Handling Tips</h2>
                          <p className="mob-none">
                            Use these Do’s and Don’ts for solving all packaging
                            tips
                          </p>
                        </div>
                      </Grid2>

                      <Grid2 size={{ sm: 12, md: 8 }}>
                        <Grid2 container spacing={2}>
                          {serviceDetails.handlingTips.map((tip) => (
                            <Grid2 key={tip.id} size={6}>
                              <div className="handling-tips-card">
                                <div className="inner-content">
                                  <h3>{tip.title}</h3>
                                  <p>{tip.description}</p>
                                </div>
                                <div className="handling-tips-img">
                                  <img src={tip.imageURL} alt={tip.title} />
                                </div>
                              </div>
                            </Grid2>
                          ))}
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Container>
                )
              )}

              {loading ? (
                <Container className="dish-packaging-container">
                  <Grid2
                    container
                    spacing={2}
                    className="inner-content-gap xs-gap-8"
                  >
                    <Grid2 size={12} id="packaging_options">
                      <div className="section-title section-title-mob mob-mb-8">
                        <h2>Packaging Options</h2>
                        <p>
                          Check vendors providing you with different packaging
                          options
                        </p>
                      </div>
                    </Grid2>

                    {Array.from({ length: isMobile ? 4 : 4 }).map((_, index) =>
                      isMobile ? (
                        <SwiperSlide key={index}>
                          <PackagingCardSkeleton />
                        </SwiperSlide>
                      ) : (
                        <Grid2 key={index} size={{ sm: 4, lg: 3, xs: 6 }}>
                          <PackagingCardSkeleton />
                        </Grid2>
                      )
                    )}
                  </Grid2>
                </Container>
              ) : (
                Array.isArray(serviceDetails?.packagingOptions) &&
                serviceDetails.packagingOptions.length > 0 && (
                  <Container className="dish-packaging-container">
                    <Grid2
                      container
                      spacing={2}
                      className="inner-content-gap xs-gap-8"
                    >
                      <Grid2 size={12} id="packaging_options">
                        <div className="section-title section-title-mob mob-mb-8">
                          <h2>Packaging Options</h2>
                          <p>
                            Check vendors providing you with different packaging
                            options
                          </p>
                        </div>
                      </Grid2>

                      {isMobile ? (
                        <Swiper
                          className="dish-packaging-options-slider"
                          modules={[Pagination]}
                          pagination={{ clickable: true }}
                          slidesPerView={"auto"}
                          spaceBetween={8}
                        >
                          {serviceDetails.packagingOptions.map(
                            (option, index) => (
                              <SwiperSlide key={index}>
                                <PackagingCard
                                  packagingInfo={option}
                                  title={option.productName}
                                  description={`${option.noOfVendorOptions} Vendor options`}
                                  price={`${option.basePrice}`}
                                  image={option.imageURL}
                                  tag={`Vendors: ${option.noOfVendorOptions}`}
                                  link={`${category}/${subCategoryURL}/packaging-options`}
                                  state={{
                                    subCategoryId: id,
                                    subCategoryName:
                                      serviceDetails?.subCategoryName,
                                    subCategoryUrl: subCategoryUrl,
                                    productUrl: option.productUrl,
                                    id: option.id,
                                  }}
                                />
                              </SwiperSlide>
                            )
                          )}
                        </Swiper>
                      ) : (
                        serviceDetails.packagingOptions.map((option, index) => (
                          <Grid2 key={index} size={{ sm: 4, lg: 3, xs: 6 }}>
                            <PackagingCard
                              packagingInfo={option}
                              title={option.productName}
                              description={`${option.noOfVendorOptions} Vendor options`}
                              price={`${option.basePrice}`}
                              image={option.imageURL}
                              tag={`Vendors: ${option.noOfVendorOptions}`}
                              link={`${category}/${subCategoryURL}/packaging-options`}
                              state={{
                                subCategoryUrl: subCategoryUrl,
                                subCategoryName:
                                  serviceDetails?.subCategoryName,
                                productUrl: option.productUrl,
                                id: option.id,
                              }}
                            />
                          </Grid2>
                        ))
                      )}
                    </Grid2>
                  </Container>
                )
              )}
            </section>
          </div>
        </>
      )}
    </>
  );
};

export default DishPackagingInfo;
